<template>
    <div v-if="visible" class="bg-white card mb-2">
        <div class="card-body d-flex justify-content-evenly" style="gap: 1.25rem">
            <div>
                <div class="bg-info text-white d-inline-flex align-items-center justify-content-center toast-icon">
                    <i class="far fa-file-pdf"></i>
                </div>
            </div>

            <div>
                <p class="my-3">{{ mainText }}</p>
            </div>
        </div>
    </div>
</template>

<script>
import { testIsNonEmptyString } from '../../../../../lib/test-and-assert/test-base';
import { eventBus } from '../../../../../lib/event-bus/event-bus';
import { TOAST_HIDE, TOASTS } from './toast-consts';
import TransFilter from '../mixins/TransFilter.vue';
import { ApiJob } from '../../../../../model/converter/api-job';
import { globalLogger } from '../../../../helper/global-logger';

export default {
    name: TOASTS.TOAST_RESULT_PDFA_CONVERSION,
    mixins: [TransFilter],
    props: {
        data: {
            type: ApiJob | null,
            default: null,
        },
    },
    beforeMount() {
        this.visible = true;
    },
    computed: {
        mainText() {
            return this.translate(
                'After the conversion to PDF/A, we have also executed a validation run to make sure, it is indeed a valid PDF/A document. The result is: "Validation rules against ISO 19005-2:2011, Level B"'
            );
        },
    },
    methods: {},
    data() {
        return {
            visible: false,
        };
    },
};
</script>

<style scoped lang="scss">
@use '../../../../../../scss/abstracts/mixins' as *;
@use '../../../../../../scss/abstracts/functions' as *;
@use '../../../../../../scss/abstracts/variables' as *;
@use '../../../../../../../../../../../assets/scss/abstracts/variables' as *;

.toast-icon {
    border-radius: 50%;
    width: 5rem;
    height: 5rem;
    font-size: 3rem;

    @media (max-width: $screen-xs-max) {
        width: 4rem;
        height: 4rem;
        font-size: 2.5rem;
    }
}

.toast-close:before,
.toast-close:after {
    position: absolute;
    left: 12px;
    content: ' ';
    height: 1.5rem;
    width: 2px;
    background-color: #333;
}

.toast-close:before {
    transform: rotate(45deg);
}

.toast-close:after {
    transform: rotate(-45deg);
}

.toast-close {
    position: relative;
    width: 1.5rem;
    height: 1.5rem;
    opacity: 0.8;

    &:hover {
        opacity: 1;
    }
}
</style>
